import { assign } from 'xstate';

import { type BundleMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Moves the highlighted product into the bundle.
 */
export const confirmPendingProduct: BundleMachineAction = assign((args) => {
  const { context } = args;

  const { pendingProduct, selectedProducts, nextSelectionId } = context;

  if (!pendingProduct) return { pendingProduct: undefined };

  return {
    selectedProducts: [
      ...selectedProducts,
      { ...pendingProduct, selectionId: String(nextSelectionId) },
    ],
    pendingProduct: undefined,
    nextSelectionId: nextSelectionId + 1,
  };
});
